
import React from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../componentes/loading/loading";

const DashboardLinePointChart = ({ orcadoObj = {}, realizadoObj = {}, realizadoObjAnterior = {}, loading = false, ano }) => {
  const labels = Array.from(new Set([...Object.keys(orcadoObj), ...Object.keys(realizadoObj), ...Object.keys(realizadoObjAnterior)]));

  const dataOrcado = labels.map((c) => orcadoObj[c] || 0);
  const dataRealizado = labels.map((c) => realizadoObj[c] || 0);
  const dataRealizadoAnterior = labels.map((c) => realizadoObjAnterior[c] || 0);

  const todosZerados = [...dataOrcado, ...dataRealizado].every((valor) => valor === 0);

  const temAnoAnterior = ano?.some(a => a < 2026);
  const somente2026 = ano?.length === 1 && ano.includes(2026);

  let series = [
    { name: "Orçado", data: dataOrcado },
    { name: "Realizado", data: dataRealizado }
  ];

  if (somente2026 && !temAnoAnterior) {
    series.push({
      name: "Realizado em 2025",
      data: dataRealizadoAnterior
    });
  }


  const options = {
    chart: {
      type: "line",
      toolbar: { show: true }, // ✅ Toolbar ativa
      animations: {
        enabled: false
      }
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    markers: {
      size: 5,
      hover: { size: 7 },
    },
    colors: ["#271de0ff", "#e03737ff", "#ff9900"],
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: labels,
      labels: {
        rotate: -45, // Inclinação para evitar corte
        style: { fontSize: "12px" },
      },
    },

    yaxis: {
      logarithmic: false,
      labels: {
        formatter: (value) =>
          new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            maximumFractionDigits: 0,
          }).format(value),
      },
    },
    tooltip: {
      y: {
        formatter: (val) =>
          val?.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
      fontSize: "12px",
    },
    grid: {
      yaxis: { lines: { show: true } },
      xaxis: { lines: { show: false } },
    },
  };

  return (
    <div className="min-h-[326px]">
      {loading ? (
        <div className="flex justify-center items-center">
          <Loading />
        </div>
      ) : todosZerados ? (
        <p className="text-muted-foreground text-center">
          Não há dados disponíveis para exibir o gráfico.
        </p>
      ) : (
           <Chart options={options} series={series} type="line" height={310} />
      )}
    </div>
  );
};

export default DashboardLinePointChart;
